/* Precise Coffee — home buying guide machine finder. Loaded by sections/pc-buying-guide.liquid. */
(function(){
  var SHOP_ESP={href:"/collections/espresso-machines-1",label:"Shop espresso machines"};
  var TYPES = {
    pod:{name:"Pod / capsule", price:"£70–£250", short:"Pod machine",
      why:"Quick, tidy and consistent for one or two drinks a day. No grinder and no mess, but the least control and the dearest cup.",
      pros:["Coffee in under a minute","No skill or cleaning","Smallest footprint"],
      cons:["Highest cost per cup","Locked into pods","Milk needs a separate frother"],
      chips:["No grinder","Low upkeep"],
      t:[2,5,5,1,5], best:"1–2 drinks a day, tight worktops",
      note:"We don't sell pod machines. If you want one-button convenience with fresh beans, look at bean-to-cup instead."},
    filter:{name:"Filter / batch brewer", price:"£40–£300", short:"Filter machine",
      why:"Brews a jug of black coffee at once. Simple, cheap to run and ideal if your household drinks mugs of black coffee rather than espresso-based drinks.",
      pros:["Cheapest per cup","A few mugs at once","Very easy to use"],
      cons:["No espresso or milk texturing","Coffee stales on the hotplate","Still better with a grinder"],
      chips:["Jug / carafe","No pressure"],
      t:[3,5,4,5,5], best:"Black coffee households",
      note:"We don't sell filter machines, but our single-dose grinders are excellent for filter brewing."},
    b2c:{name:"Bean-to-cup", price:"£300–£1,600", short:"Bean-to-cup",
      why:"Grinds fresh beans and makes espresso and milk drinks at the touch of a button. The easiest route to fresh coffee at home, with a ceiling on how good it can get.",
      pros:["Fresh beans, no skill needed","One-touch milk drinks","Fair cost per cup"],
      cons:["Daily milk-system cleaning","Good, not café-quality, milk and espresso","Harder to repair long term"],
      chips:["Built-in grinder","Auto milk"],
      t:[3,5,4,4,3], best:"Busy families, mixed drinks",
      shop:{href:"/collections/bean-to-cup",label:"Shop bean-to-cup machines"}},
    starter:{name:"Starter espresso machine", price:"£150–£600 + grinder £100–£250", short:"Starter espresso",
      why:"A compact thermoblock machine with a portafilter and steam wand. The classic first step: you learn to grind, dose, tamp and steam, and it rewards you quickly.",
      pros:["Real espresso and steamed milk","Low cost per cup","Compact and fast to heat"],
      cons:["Waits between brewing and steaming","Smaller baskets, fewer upgrades","Temperature can wander"],
      chips:["Thermoblock","Steam wand"],
      t:[3,2,3,4,3], best:"A first espresso machine",
      note:"Our range starts one rung up, with PID-controlled machines from around £1,000. If a starter machine is right for you, we'd rather say so than sell you more than you need."},
    fast:{name:"Fast-heating PID espresso", price:"£900–£1,800 + grinder £200–£500", short:"Fast-heat PID",
      why:"Thermoblocks or a small boiler under digital PID control, with a dedicated steam system so you can brew and steam together. Ready in about five minutes, often with pressure profiling or a touchscreen.",
      pros:["Ready in minutes","Brew and steam at once","Modern controls: profiling, timers"],
      cons:["Less thermal mass than a boiler machine","More electronics to look after","Vibration pumps can be buzzy"],
      chips:["PID","58 mm","5 min warm-up"],
      t:[4,3,4,4,3], best:"Daily espresso, impatient mornings",
      shop:SHOP_ESP},
    hx:{name:"Heat exchanger (E61)", price:"£1,100–£2,500 + grinder £200–£600", short:"Heat exchanger",
      why:"One large boiler held at steam temperature, with brew water heated on the way through. The classic Italian home machine: a heavy E61 group, powerful steam, and brew and steam at the same time.",
      pros:["Powerful, dry steam","Classic build, lasts decades","Brew and steam together"],
      cons:["20–25 minute warm-up (use a timer)","Short cooling flush before each shot","Heavy and deep"],
      chips:["E61","HX boiler"],
      t:[4,2,4,4,3], best:"Milk drinks, traditionalists",
      shop:SHOP_ESP},
    dual:{name:"Dual boiler", price:"£1,900–£4,000 + grinder £300–£800", short:"Dual boiler",
      why:"Separate brew and steam boilers, each with its own PID. Set the brew temperature to the bean and steam at full power at the same time. The most capable home espresso format.",
      pros:["Precise, settable brew temperature","Unlimited back-to-back milk drinks","Built to last 15+ years"],
      cons:["Biggest and heaviest","Long warm-up unless on a timer","Highest price"],
      chips:["Dual PID","E61 or saturated group","58 mm"],
      t:[5,2,5,4,2], best:"Enthusiasts, busy households",
      shop:SHOP_ESP},
    lever:{name:"Lever espresso", price:"£2,500–£4,000 + grinder £300–£800", short:"Lever",
      why:"A spring lever replaces the pump. You pre-infuse and pull the shot by hand, shaping the pressure as it falls. Quiet, beautiful and endlessly involving, with a big boiler and a tall footprint.",
      pros:["Near-silent, no pump","Natural pressure profiling","A ritual as much as a machine"],
      cons:["Needs practice","Tall: check cupboard height","Usually plumb-in only"],
      chips:["Spring lever","Plumbed-in"],
      t:[5,1,3,4,2], best:"The committed hobbyist",
      shop:SHOP_ESP}
  };
  var ORDER=["pod","filter","b2c","starter","fast","hx","dual","lever"];

  var SCORES = {
    drink:{milk:{b2c:3,dual:2,hx:2,fast:2,starter:1,lever:1,filter:-4},
           espresso:{starter:2,fast:2,lever:2,hx:1,dual:1,b2c:1,pod:1,filter:-3},
           filter:{filter:5,b2c:1,starter:-2,fast:-2,hx:-2,dual:-2,lever:-2},
           mix:{b2c:3,hx:1,dual:1,fast:1,filter:1}},
    effort:{push:{b2c:4,pod:3,filter:2,fast:-2,starter:-3,hx:-3,dual:-3,lever:-5},
            some:{fast:3,hx:2,starter:2,dual:1,b2c:1,filter:1,lever:-2},
            hobby:{lever:3,dual:3,hx:2,fast:2,starter:1,filter:-1,b2c:-3,pod:-4}},
    morning:{solo:{pod:2,starter:2,fast:1,b2c:1,lever:1,dual:-1},
             pair:{fast:2,hx:2,dual:2,b2c:2,starter:-1,pod:-1},
             crowd:{dual:3,hx:2,filter:2,b2c:2,lever:1,starter:-3,pod:-3}},
    budget:{1:{pod:4,filter:4,starter:1,b2c:-3,fast:-6,hx:-6,dual:-6,lever:-6},
            2:{starter:4,b2c:2,pod:1,filter:1,fast:-3,hx:-4,dual:-6,lever:-6},
            3:{fast:3,b2c:3,starter:1,hx:1,dual:-3,lever:-4},
            4:{hx:3,dual:3,fast:1,b2c:1,starter:-1,pod:-1},
            5:{dual:3,lever:3,hx:2,fast:1,starter:-2,pod:-2,filter:-1}},
    space:{tight:{pod:2,starter:2,fast:1,b2c:-1,dual:-1,lever:-3},
           std:{},
           corner:{lever:2,dual:2,hx:1}}
  };

  function dots(n){var s="";for(var i=0;i<n;i++)s+="●";var e="";for(var j=n;j<5;j++)e+="●";return s+"<i>"+e+"</i>";}
  function esc(s){return String(s).replace(/&/g,"&amp;").replace(/[<]/g,"&lt;").replace(/"/g,"&quot;");}
  function el(id){return document.getElementById(id);}

  var cards=el("pcbg-typecards"), table=el("pcbg-ctable"), quiz=el("pcbg-quiz");
  if(!cards||!table||!quiz) return;

  cards.innerHTML = ORDER.map(function(k){var t=TYPES[k];return ''+
    '<article class="pcbg-type" id="pcbg-type-'+k+'">'+
      '<div class="pcbg-row"><h3 class="pcbg-h3">'+esc(t.name)+'</h3><span class="pcbg-band">'+esc(t.price)+'</span></div>'+
      '<p>'+esc(t.why)+'</p>'+
      '<div class="pcbg-pc"><div class="pcbg-pro"><h4>Good</h4><ul>'+t.pros.map(function(x){return '<li>'+esc(x)+'</li>';}).join('')+'</ul></div>'+
      '<div class="pcbg-con"><h4>Watch out</h4><ul>'+t.cons.map(function(x){return '<li>'+esc(x)+'</li>';}).join('')+'</ul></div></div>'+
      (t.note?'<p class="pcbg-r-note">'+esc(t.note)+'</p>':'')+
      '<div class="pcbg-meta">'+t.chips.map(function(c){return '<span class="pcbg-chip">'+esc(c)+'</span>';}).join('')+
        (t.shop?'<a class="pcbg-type-shop" href="'+esc(t.shop.href)+'">'+esc(t.shop.label)+' →</a>':'')+
      '</div>'+
    '</article>';}).join('');

  table.innerHTML = ORDER.map(function(k){var t=TYPES[k];return '<tr><th scope="row">'+esc(t.name)+'</th>'+
    t.t.map(function(n){return '<td><span class="pcbg-dots" aria-label="'+n+' out of 5">'+dots(n)+'</span></td>';}).join('')+
    '<td>'+esc(t.best)+'</td></tr>';}).join('');

  function answers(){var a={};var inputs=quiz.querySelectorAll('input[type=radio]:checked');for(var i=0;i<inputs.length;i++){a[inputs[i].name]=inputs[i].value;}return a;}
  function update(){
    var a=answers(), s={}; ORDER.forEach(function(k){s[k]=0;});
    for(var q in a){var m=(SCORES[q]||{})[a[q]]||{}; for(var k in m) s[k]+=m[k];}
    var ranked=ORDER.slice().sort(function(x,y){return s[y]-s[x];});
    var vals=ORDER.map(function(k){return s[k];});
    var min=Math.min.apply(null,vals), max=Math.max.apply(null,vals);
    var pct=function(k){return max===min?50:Math.round(8+92*(s[k]-min)/(max-min));};
    var top=TYPES[ranked[0]], second=TYPES[ranked[1]];
    el("pcbg-r-name").textContent=top.name;
    el("pcbg-r-price").textContent="Typical price: "+top.price;
    el("pcbg-r-why").textContent=top.why;
    el("pcbg-r-points").innerHTML=top.pros.map(function(p){return '<li>'+esc(p)+'</li>';}).join('');
    var note=el("pcbg-r-note");
    if(note){ if(top.note){note.textContent=top.note;note.hidden=false;}else{note.hidden=true;} }
    var shop=el("pcbg-r-shop");
    if(top.shop){shop.href=top.shop.href;shop.textContent=top.shop.label;shop.hidden=false;}else{shop.hidden=true;}
    el("pcbg-r-runner").innerHTML='Also worth a look: <b>'+esc(second.name)+'</b> ('+esc(second.price)+'). Best for '+esc(second.best.toLowerCase())+'.';
    el("pcbg-r-bars").innerHTML=ranked.map(function(k,i){return '<div class="pcbg-bar'+(i===0?' pcbg-top':'')+'"><span>'+esc(TYPES[k].short)+'</span><div class="pcbg-track"><div class="pcbg-fill" style="width:'+pct(k)+'%"></div></div><span class="pcbg-pct">'+pct(k)+'</span></div>';}).join('');
  }
  quiz.addEventListener("change",update);
  update();
})();
